import React, { useEffect, useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { PacmanLoader } from 'react-spinners';
import { useAuth } from '../contexts/AuthContext';

export default function AuthCallback() {
  const [status, setStatus] = useState('processing');
  const [error, setError] = useState(null);
  const { checkAuthStatus } = useAuth();
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();

  useEffect(() => {
    const handleCallback = async () => {
      try {
        const code = searchParams.get('code');
        const urlError = searchParams.get('error');

        if (urlError) {
          setError(urlError);
          setStatus('error');
          return;
        }

        if (code) {
          const apiTarget = import.meta.env.VITE_API_TARGET || 'http://localhost:5174';
          const response = await fetch(`${apiTarget}/api/auth/google/callback?code=${code}`, {
            credentials: 'include',
          });

          if (response.ok) {
            await checkAuthStatus();
            setStatus('success');

            setTimeout(() => {
              navigate('/creative-manager', { replace: true });
            }, 1500);
          } else {
            try {
              const errorData = await response.json();
              setError(errorData.detail || 'Authentication failed');
            } catch {
              setError('Authentication failed');
            }
            setStatus('error');
          }
        } else {
          setError('No authorization code received');
          setStatus('error');
        }
      } catch (err) {
        console.error('Callback error:', err);
        setError('An unexpected error occurred');
        setStatus('error');
      }
    };

    handleCallback();
  }, [checkAuthStatus, searchParams, navigate]);

  if (status === 'processing') {
    return (
      <div className="auth-callback">
        <div className="callback-container">
          <div className="loading-spinner">
            <PacmanLoader color="#fbbf24" size={30} />
            <p>Completing authentication...</p>
          </div>
        </div>
      </div>
    );
  }

  if (status === 'error') {
    return (
      <div className="auth-callback">
        <div className="callback-container">
          <div className="error-card">
            <div className="error-icon">❌</div>
            <h2>Authentication Failed</h2>
            <p>{error}</p>
            <button 
              className="retry-button"
              onClick={() => navigate('/login', { replace: true })}
            >
              Back to Login
            </button>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="auth-callback">
      <div className="callback-container">
        <div className="success-card">
          <div className="success-icon">✅</div>
          <h2>Authentication Successful!</h2>
          <p>Redirecting to dashboard...</p>
        </div>
      </div>
    </div>
  );
}
